import { render, staticRenderFns } from "./ServicesReservationCalendarInfo.vue?vue&type=template&id=2a2f6a2a&"
import script from "./ServicesReservationCalendarInfo.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationCalendarInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports